import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const CustomYearPicker = ({ value, onChange }) => {
  const [selectedYear, setSelectedYear] = useState(null);

  // Sync UI when formik resets/updates
  useEffect(() => {
    if (!value) {
      setSelectedYear(null);
    } else {
      setSelectedYear(parseInt(value));
    }
  }, [value]);

  const handleChange = (date) => {
    if (!date) {
      setSelectedYear(null);
      onChange(null);
      return;
    }

    const year = date.year();
    setSelectedYear(year);
    onChange(year.toString());
  };

  return (
    <DatePicker
      picker="year"
      placeholder="Select Year"
      value={selectedYear ? dayjs().year(selectedYear) : null}
      onChange={handleChange}
      style={{ width: "100%" }}
    />
  );
};

export default CustomYearPicker;
